import React from 'react';
import PropTypes from 'prop-types';

import { I18n } from 'Locales';
import { RowView } from 'Containers';
import { MODAL_SIZES } from 'Constants';
import { Button, Modal } from 'Components';

const ReloadAppModal = ({ isOpen = false }) => (
  <Modal open={isOpen} size={MODAL_SIZES.EXTRA_SMALL} closeByBackdropClick={false}>
    <Modal.Title>
      <div className="text-md font-bold">{I18n.t('flow:newFlowVersionAvailable.title')}</div>
    </Modal.Title>

    <Modal.Content contentPosition={'flex-start'}>
      <RowView>{I18n.t('flow:newFlowVersionAvailable.description')}</RowView>
    </Modal.Content>

    <Modal.Actions>
      <Button.Primary className="line-height-normal" width={'100%'} onClick={() => window.location.reload()}>
        {I18n.t('general:reload')}
      </Button.Primary>
    </Modal.Actions>
  </Modal>
);

ReloadAppModal.propTypes = {
  isOpen: PropTypes.bool
};

export default ReloadAppModal;
